(() => {
'use strict';
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
function setup(scope = document) {
  scope.querySelectorAll('[data-gallery-hero]:not([data-gallery-ready])').forEach(hero => {
    hero.dataset.galleryReady = 'true';
    const slides = [...hero.querySelectorAll('[data-gallery-slide]')];
    const buttons = [...hero.querySelectorAll('[data-gallery-select]')];
    const marks = [...hero.querySelectorAll('[data-gallery-mark]')];
    let active = 0;
    const select = (index, focus = false) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide,i) => { slide.classList.toggle('is-active', i === active); slide.setAttribute('aria-hidden',String(i !== active)); });
      buttons.forEach((button,i) => { button.classList.toggle('is-active',i === active); button.setAttribute('aria-pressed',String(i === active)); });
      marks.forEach((mark,i) => mark.classList.toggle('is-active',i === active));
      const cta = hero.querySelector('[data-gallery-cta]');
      if (cta && slides[active].dataset.galleryLink) cta.href = slides[active].dataset.galleryLink;
      const heading = hero.querySelector('h1[data-gallery-title]');
      const description = hero.querySelector('p[data-gallery-description]');
      if (heading) heading.textContent = slides[active].dataset.galleryTitle || '';
      if (description) description.textContent = slides[active].dataset.galleryDescription || '';
      const label = buttons[active]?.getAttribute('aria-label');
      hero.querySelector('[data-gallery-status]').textContent = label || '';
      if (focus) buttons[active]?.focus({preventScroll:true});
    };
    buttons.forEach((button,i) => {
      button.addEventListener('click',()=>select(i));
      button.addEventListener('keydown',event=>{let index=i;if(event.key==='ArrowRight')index=i+1;else if(event.key==='ArrowLeft')index=i-1;else if(event.key==='Home')index=0;else if(event.key==='End')index=slides.length-1;else return;event.preventDefault();select(index,true);});
    });
    let start = null;
    const stage = hero.querySelector('.art-house-stage');
    stage.addEventListener('pointerdown',e=>{if(e.isPrimary)start={x:e.clientX,y:e.clientY};},{passive:true});
    stage.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5)select(active+(dx<0?1:-1));},{passive:true});
    stage.addEventListener('pointercancel',()=>start=null,{passive:true});
    hero.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-gallery-slide]');if(slide)select(Number(slide.dataset.gallerySlide));});
  });
}
let ticking = false;
function animate(){ticking=false;const motion=window.Miorlune?.motion!==false&&!reduced.matches;document.querySelectorAll('[data-gallery-hero]').forEach(hero=>{const r=hero.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const shift=motion&&hero.dataset.motion!=='false'?Math.max(0,Math.min(14,-r.top*.025)):0;hero.style.setProperty('--art-shift',shift+'px');});}
function request(){if(!ticking){ticking=true;requestAnimationFrame(animate);}}
window.addEventListener('scroll',request,{passive:true});reduced.addEventListener('change',request);document.addEventListener('shopify:section:load',e=>setup(e.target));setup();
})();
